import styled from 'styled-components/macro'

const ListItemText = styled.div`
  flex: 1;
`

export default ListItemText
